import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import gifs from "../../assets/icons/gifs.png";
import coins from "../../assets/icons/coins.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const { t } = useTranslation();

  const [text, setText] = useState(`${t("bannerTitle")}`);

  useEffect(() => {
    const interval = setInterval(() => {
      setText((prevText) =>
        prevText === `${t("bannerTitle")}` ? "" : `${t("bannerTitle")}`
      );
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={style.banner}>
      <Link
        onClick={async () => {
          if (window.ym) {
            await window.ym(100582088, "reachGoal", "banner");
          }
        }}
        to="/conversion"
      >
        <img src={gifs} alt="gifs" />
        <div className={style.banner__text}>
          <h2>
            {text !== `${t("bannerTitle")}` && (
              <div>
                <svg
                  width="150"
                  height="30"
                  viewBox="0 0 150 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M89.6864 8.26676C84.8627 8.26676 80.4009 12.0093 80.4009 17.7045C80.4009 23.3997 84.8627 27.1423 89.6864 27.1423C94.51 27.1423 98.9718 23.3997 98.9718 17.7045C98.9718 12.0093 94.51 8.26676 89.6864 8.26676ZM89.6864 22.3258C87.3047 22.3258 85.3752 20.243 85.3752 17.672C85.3752 15.101 87.3047 13.0182 89.6864 13.0182C92.068 13.0182 93.9975 15.101 93.9975 17.672C93.9975 20.243 92.068 22.3258 89.6864 22.3258ZM52.243 8.68983H57.4887V26.6867H52.243V8.68983ZM57.971 3.1248C57.971 4.88218 56.5541 6.24903 54.8658 6.24903C53.1776 6.24903 51.7606 4.88218 51.7606 3.1248C51.7606 1.36743 53.1776 0.000579834 54.8658 0.000579834C56.5541 0.0331238 57.971 1.36743 57.971 3.1248ZM78.2604 17.7045V26.6867H73.0147V18.1276C73.0147 15.101 71.9294 13.3436 69.5779 13.3436C67.2264 13.3436 66.141 15.101 66.141 18.1276V26.6867H60.8954V17.7045C60.8954 12.0093 64.2719 8.26676 69.5779 8.26676C74.8839 8.26676 78.2604 12.0093 78.2604 17.7045ZM129.24 17.5418V26.6867H123.994V17.5418C123.994 14.8081 122.939 13.3436 120.889 13.3436C118.839 13.3436 117.784 14.8081 117.784 17.5418V26.6867H112.538V17.5418C112.538 14.8081 111.483 13.3436 109.433 13.3436C107.383 13.3436 106.328 14.8081 106.328 17.5418V26.6867H101.142V17.5418C101.142 11.8466 104.73 8.26676 109.493 8.26676C111.935 8.26676 113.895 9.21053 115.221 10.9028C116.548 9.21053 118.508 8.26676 120.949 8.26676C125.653 8.26676 129.24 11.8466 129.24 17.5418ZM140.696 8.26676C135.873 8.26676 131.411 12.0093 131.411 17.7045C131.411 23.3997 135.873 27.1423 140.696 27.1423C145.52 27.1423 149.982 23.3997 149.982 17.7045C149.982 12.0093 145.52 8.26676 140.696 8.26676ZM140.696 22.3258C138.315 22.3258 136.385 20.243 136.385 17.672C136.385 15.101 138.315 13.0182 140.696 13.0182C143.078 13.0182 145.007 15.101 145.007 17.672C145.007 20.243 143.078 22.3258 140.696 22.3258ZM40.5155 8.26676C38.7067 8.26676 37.1993 8.75492 36.0235 9.69869V0.260933H30.8984V16.6957C30.8984 23.3021 35.089 27.1423 40.0935 27.1423C45.098 27.1423 49.4995 23.3997 49.4995 17.7045C49.5297 12.0093 45.3392 8.26676 40.5155 8.26676ZM40.2744 22.3258C37.8927 22.3258 35.9632 20.243 35.9632 17.672C35.9632 15.101 37.8927 13.0182 40.2744 13.0182C42.656 13.0182 44.5855 15.101 44.5855 17.672C44.5855 20.243 42.656 22.3258 40.2744 22.3258Z"
                    fill="#353535"
                  />
                  <path
                    d="M11.587 0.559302C9.73956 -0.592068 7.37732 0.0912015 6.31073 2.08542L0.518123 12.9152C-0.548476 14.9095 0.0844858 17.4595 1.93188 18.6109C3.77927 19.7623 6.14152 19.079 7.2081 17.0848L13.0007 6.25493C14.0673 4.26069 13.4343 1.71067 11.587 0.559302Z"
                    fill="#353535"
                  />
                  <path
                    d="M17.3873 11.3891C15.5399 10.2377 13.1777 10.921 12.1111 12.9152L6.31846 23.7451C5.25186 25.7393 5.88483 28.2893 7.73222 29.4407C9.57961 30.5921 11.9419 29.9088 13.0084 27.9146L18.8011 17.0847C19.8676 15.0905 19.2347 12.5405 17.3873 11.3891Z"
                    fill="#353535"
                  />
                </svg>
              </div>
            )}
            {text}
          </h2>
          <p>
            {t("bannerText")}{" "}
            <Link
              onClick={() => {
                if (window.ym) {
                  window.ym(98661745, "reachGoal", "binomial_start");
                }

                if (window.fbq !== undefined) {
                  window.fbq("track", "CompleteRegistration");
                }
              }}
              to="https://blog.binomo.com/tradinggame2025/"
              target="_blank"
              rel="noreferrer"
            >
              {t("bannerLink")}
            </Link>
          </p>
        </div>
        <img src={coins} alt="coins" />
      </Link>
    </div>
  );
};

export default Banner;
